import { hash } from '@ember/helper';
import RowReview from './row-review.gts';
import { t } from 'ember-intl';
import ToggleRow from './toggle-row.gts';
import type { TuitionAssistanceProgramTemplateReviewToggleRowSignature } from './toggle-row.ts';
import type { TuitionAssistanceProgramTemplateReviewRowReviewSignature } from './row-review.ts';
import type { TOC } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';
import { Section } from 'tio-ui/components/layout';

interface S {
  Args: {
    isEditable?: boolean;
    title: string;
  };
  Blocks: {
    default: [
      {
        row: ComponentLike<TuitionAssistanceProgramTemplateReviewToggleRowSignature>;
        rowReview: ComponentLike<TuitionAssistanceProgramTemplateReviewRowReviewSignature>;
      },
    ];
  };
}

const TasProgramTemplateReviewTableLayout: TOC<S> = <template>
  <Section>
    <:header>
      {{@title}}
    </:header>
    <:body>
      <div class="grid grid-cols-5 gap-4 font-semibold bg-ocean-50 p-4 mb-8">
        <span class="col-span-1">{{t
            "common.tuition_assistance.program_template_review.field"
          }}</span>
        <span class="col-span-1 justify-self-center">
          {{t "common.tuition_assistance.program_template_review.visible_to_employees"}}
        </span>
        <span class="col-span-1 justify-self-center">
          {{t "common.required"}}
        </span>
        <span class="col-span-1 justify-self-start">
          {{t "common.tuition_assistance.program_template_review.use_custom_field_options"}}
        </span>
        {{#if @isEditable}}
          <span class="col-span-1">{{t "common.description"}}</span>
        {{/if}}
      </div>

      <div class="grid grid-cols-5 gap-8 m-4 text-sm">
        {{yield (hash row=(component ToggleRow) rowReview=(component RowReview))}}
      </div>
    </:body>
  </Section>
</template>;

export default TasProgramTemplateReviewTableLayout;
